import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const chillCumulativePortionsMAR: typeof valueTypeRenderers.chillCumulativePortionsMAR = {
  label: () => unitConverter.chillCumulativePortionsMAR().title(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.chillCumulativePortionsMAR().title(),
      render: (n) => unitConverter.chillCumulativePortionsMAR(n).valueAsString(),
    }),
}
